import TicketWithLink from '../../components/atoms/tickets/TicketWithLink'
import FeedbackSuccess from '../../components/atoms/feedbacks/feedback-success'
import FeedbackError from '../../components/atoms/feedbacks/feedback-error'
import AccountIconWh24 from '../../components/atoms/account_icons/AccountIconWh24'
import AccountIconWh40 from '../../components/atoms/account_icons/AccountIconWh40'

export default {
  data() {
    return {
      sender: '',
      content: '',
      isActive: false,
      hasError: false,
      hasSuccess: false,
      showableSignUpModal: false,
      isFocusSender: false,
      isFocusContent: false
    }
  },
  components: {
    TicketWithLink,
    FeedbackSuccess,
    FeedbackError,
    AccountIconWh24,
    AccountIconWh40
  },
  mounted() {
    const replySenderHtml = document.querySelector('#gift-reply-sender')
    if (replySenderHtml) {
      const replySender = replySenderHtml.outerHTML.match(/value="(.*?)"/)
      if (replySender) {
        this.sender = replySender[1]
      }
    }

    const replyContentHtml = document.querySelector('#gift-reply-content')
    if (replyContentHtml) {
      const replyContent = replyContentHtml.textContent
      if (replyContent) {
        this.content = replyContent
      }
    }

    const replySuccessFeedback = document.querySelector(
      '.reply-feedback--success'
    )
    if (replySuccessFeedback) {
      this.hasSuccess = true
      this.enterSuccess()
    }
    const replyErrorFeedback = document.querySelector('.reply-feedback--error')
    if (replyErrorFeedback) {
      this.hasError = true
      this.enterError()
    }
  },
  computed: {
    isNotEmptySender() {
      return this.sender.length !== 0
    },
    isNotEmptyContent() {
      return this.content.length !== 0
    },
    isSubmittable() {
      return this.isNotEmptySender && this.isNotEmptyContent
    }
  },
  methods: {
    showExplanation() {
      this.isActive = !this.isActive
    },
    onSenderFocus() {
      this.isFocusSender = true
    },
    onSenderBlur() {
      this.isFocusSender = false
    },
    onContentFocus() {
      this.isFocusContent = true
    },
    onContentBlur() {
      this.isFocusContent = false
    },
    enterSuccess() {
      setTimeout(() => {
        this.hasSuccess = false
      }, 3000)
    },
    enterError() {
      setTimeout(() => {
        this.hasError = false
      }, 3000)
    },
    onClickSignUpLink() {
      dataLayer.push({
        event: 'signup_click',
        button: 'gift_save'
      })
    },
    onClickSignInLink() {
      dataLayer.push({
        event: 'signin_click',
        button: 'gift_save'
      })
    },
    onClickSaveLink() {
      dataLayer.push({
        event: 'save_click'
      })
    }
  }
}
